import cookies from "./cookies";

export enum AuthKeys {
  ACCESS_TOKEN = "access_token",
  REFRESH_TOKEN = "refresh_token",
  EXPIRES_IN = "expires_at",
  EMAIL = "email",
}

const getAccessToken = () => cookies.getItem(AuthKeys.ACCESS_TOKEN);

export default {
  getAccessToken,
};
